module.exports = __webpack_public_path__ + "static/media/pic_truck@2x.7e158f61.png";